import { createContext, useContext } from 'react';
import { resolvePublicFileUrl } from '../utils/imageUrls';

/** Owned by one mounted Show Mode session; never shared with other builds/accounts. */
export const ShowModeAssets = createContext<ReadonlyMap<string, string> | null>(null);

export function showModeAssetKey(url: string): string {
  if (/^(blob:|data:)/i.test(url)) return url;
  return new URL(resolvePublicFileUrl(url) || url, window.location.href).href;
}

export function useShowModeAsset() {
  const assets = useContext(ShowModeAssets);
  // A missing prepared asset must never silently become another network request.
  return (url: string | null | undefined): string | undefined =>
    url ? assets === null ? url : assets.get(showModeAssetKey(url)) : undefined;
}
